import React from 'react';
import cn from 'classnames';
import { Icon, Popconfirm, Tooltip } from 'antd';
import Card, { CardIconButton } from '../../../Card';
import IconBlock from '../IconBlock/IconBlock';
import NameBlock from '../NameBlock/NameBlock';
import MetaDataBlock from '../MetaDataBlock/MetaDataBlock';
import { attachmentAdapter } from '../../utils/attachmentAdapter';
import { columnAmounts } from '../../constants/columnAmounts';
import styles from './TwoColumnGrid.module.scss';

const TwoColumnGrid = ({
  className,
  darkBackground,
  attachments,
  attachment,
  popConfirmPlacement,
  getAttachmentUrl,
  onDeleteAttachment,
  showMetaData,
  renderActions,
  renderAdditionalContent,
  canBeDeleted,
}) => {
  return (
    <Card
      dark={darkBackground}
      className={cn(styles.root, className)}
    >
      <div className={styles.topRow}>
        <div className={styles.nameBlock}>
          <IconBlock
            attachment={attachment}
            attachments={attachments}
            getAttachmentUrl={getAttachmentUrl}
          />
          <NameBlock
            attachment={attachmentAdapter(attachment)}
            getAttachmentUrl={getAttachmentUrl}
            columnAmount={columnAmounts.two}
          />
        </div>

        <div className={styles.actionsBlock}>
          {typeof renderActions === 'function' &&
            renderActions({ attachment: attachmentAdapter(attachment) })}

          {canBeDeleted && (
            <Popconfirm
              cancelText="Нет"
              okText="Да"
              onConfirm={async () => await onDeleteAttachment(attachment)}
              title="Удалить файл?"
              placement={popConfirmPlacement}
            >
              <Tooltip
                title="Удалить"
                placement="bottomRight"
              >
                <CardIconButton
                  renderIcon={() => <Icon type="close-circle" />}
                />
              </Tooltip>
            </Popconfirm>
          )}
        </div>
      </div>

      {typeof renderAdditionalContent === 'function' &&
        renderAdditionalContent({ attachment: attachmentAdapter(attachment) })}
      {showMetaData && (
        <MetaDataBlock
          columnAmount={columnAmounts.two}
          attachment={attachment}
        />
      )}
    </Card>
  );
};

export default TwoColumnGrid;
